import { VideoUIFrame } from "./VideoUIFrame";
import { useVideoUI } from "../../VideoUIContext";
import type { Action } from "@core/features/actions";
import { MeetingDetails } from "@platform/features/video/types/video.types";
import { useDialog } from "@platform/store";

type Props = {
  priorityBasedPolicy: boolean;
  sharingAttendeeId: string;
  meetingScriptAction: Action | undefined;
  meetingDetails: MeetingDetails;
};

export const VideoUIFrameContainer = ({
  priorityBasedPolicy,
  sharingAttendeeId,
  meetingScriptAction,
  meetingDetails,
}: Props) => {
  const { isSidebarOpen } = useVideoUI();

  const { openDialog } = useDialog();

  const onSupportClick = () => {
    openDialog("supportTicket");
  };

  return (
    <VideoUIFrame
      priorityBasedPolicy={priorityBasedPolicy}
      sharingAttendeeId={sharingAttendeeId}
      isSidebarOpen={isSidebarOpen}
      isSupportDialogEnabled={false}
      meetingScriptAction={meetingScriptAction}
      meetingDetails={meetingDetails}
      onSupportClick={onSupportClick}
    />
  );
};

export default VideoUIFrameContainer;
